import { render, staticRenderFns } from "./ProLabelTooltip.vue?vue&type=template&id=1ec57318&"
import script from "./ProLabelTooltip.vue?vue&type=script&lang=ts&"
export * from "./ProLabelTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports